import { render } from "./CardSelectedItems.vue?vue&type=template&id=5977dbe4"
import script from "./CardSelectedItems.vue?vue&type=script&lang=js"
export * from "./CardSelectedItems.vue?vue&type=script&lang=js"

import "./CardSelectedItems.vue?vue&type=style&index=0&id=5977dbe4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__